module.exports = __webpack_public_path__ + "img/mcc school.4c3b64d6.png";